import { Injectable } from '@angular/core';

import { ApiBase } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class VanillaApiService extends ApiBase {}
